module.exports = __webpack_public_path__ + "img/4a0df40.png";